import React from 'react';
import Head from 'next/head';
import PropTypes from 'prop-types';

const defaultTitle = 'iyiMakina A.Ş. - iyiMakina.com';

const CustomHead = ({ title }) => (
  <Head>
    <meta charSet="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <meta httpEquiv="X-UA-Compatible" content="ie=edge" />
    <title>{title ? `${title} | ${defaultTitle}` : defaultTitle}</title>
    <link rel="icon" href="/image/favicon.ico" />
    <meta
      name="description"
      content="İkinci el iş makinalarını güvenle alıp satın. Açık Artırma avantajlı makinalara, istediğiniz teklifi tek tıkla verin."
    />
    <meta name="robots" content="noindex, nofollow" />
  </Head>
);

CustomHead.propTypes = {
  title: PropTypes.string,
};

export default CustomHead;
